// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td.colOne[data-v-2fc721d4] {\n  width: 50px;\n  min-width: 50px;\n  max-width: 50px;\n}\ntd.colTwo[data-v-2fc721d4] {\n  width: 340px;\n  min-width: 340px;\n  max-width: 340px;\n}\n.sticky__export--campaign[data-v-2fc721d4] {\n  text-align: left;\n  position: sticky;\n  background-color: #ffffff;\n  top: 0;\n  z-index: 20;\n}", ""]);
// Exports
module.exports = exports;
